import YouTrendLogo from '@/assets/img/youtrend.png';
import './index.scss';

export const Footer = () => (
  <div className="Footer">
    <span>Powered by:</span>
    <a href="https://www.youtrend.it/" target="__blank">
      <div
        className="Footer__YouTrendLogo"
        style={{ backgroundImage: `url(${YouTrendLogo})` }}
      />
    </a>
  </div>
);
